// hooks/useCidades.ts
import { useFetch } from "./useFetch";
import { Cota } from "../interfaces/Cota";
import { buscarCotasByAptoService } from "../services/buscarCotasByAptoService";

export const useCotasByIdApto = (apartamentoId?: number) => {
  const { isLoading, data, error } = useFetch<Cota[]>(
    !!apartamentoId,
    buscarCotasByAptoService,
    [apartamentoId],
    apartamentoId
  );

  return { isLoading, data, error };
};
